import React from 'react';
import WalletBalanceHero, { WalletBalanceHeroProps } from './WalletBalanceHero';
import WalletWithdrawalSuccessModal from './WalletWithdrawalSuccessModal';
import WalletPayoutDetailModal from './WalletPayoutDetailModal';
import WalletPayoutsButton from './WalletPayoutsButton';
import { useWalletWithdrawalSuccess } from '../hooks/useWalletWithdrawalSuccess';

export interface ProfileWhopWalletWithdrawFlowProps {
  heroProps: Omit<WalletBalanceHeroProps, 'payoutAction'>;
  companyId: string;
  accessToken: string;
  kycApproved: boolean | null;
  onKycApprovalChange: (approved: boolean) => void;
  influencerId?: string;
  onRefreshBalance: () => void;
}

/** Profile wallet hero + post-withdrawal success modal with embedded Whop Elements. */
const ProfileWhopWalletWithdrawFlow: React.FC<ProfileWhopWalletWithdrawFlowProps> = ({
  heroProps,
  companyId,
  accessToken,
  kycApproved,
  onKycApprovalChange,
  influencerId,
  onRefreshBalance,
}) => {
  const {
    isSuccessModalOpen,
    isDetailModalOpen,
    latestWithdrawalId,
    handleWithdrawalComplete,
    handleViewStatus,
    handleCloseSuccessModal,
    handleCloseDetailModal,
  } = useWalletWithdrawalSuccess({
    influencerId,
    onRefreshBalance,
    onRefreshWithdrawals: () => undefined,
  });

  const payoutAction = (
    <WalletPayoutsButton
      companyId={companyId}
      accessToken={accessToken}
      influencerId={influencerId}
      kycApproved={kycApproved}
      onKycApprovalChange={onKycApprovalChange}
      onWithdrawalComplete={handleWithdrawalComplete}
    />
  );

  return (
    <>
      <WalletBalanceHero {...heroProps} payoutAction={payoutAction} />
      <WalletWithdrawalSuccessModal
        isOpen={isSuccessModalOpen}
        onClose={handleCloseSuccessModal}
        onViewStatus={handleViewStatus}
      />
      <WalletPayoutDetailModal
        isOpen={isDetailModalOpen}
        payoutId={latestWithdrawalId}
        influencerId={influencerId}
        onClose={handleCloseDetailModal}
      />
    </>
  );
};

export default ProfileWhopWalletWithdrawFlow;
